export const language = {
    dialog: {
        settings: {
            header: "設定",
            items: {
                motion: {
                    label: "モーションの減少",
                },
                contrast: {
                    label: "ハイコントラストモード",
                },
            },
        },
    },
    footer: {
        copyright: {
            label: "全著作権所有！",
        },
    },
    sidebar: {
        sitemap: {
            header: "サイトマップ",
        },
    },
};
